import { action, createRequestTypes } from './base';

export const grnActionTypes = {
  GET_GRN: createRequestTypes('GET_GRN'),
  GET_GRN_BY_ID: createRequestTypes('GET_GRN_BY_ID'),
  CREATE_GRN: createRequestTypes('CREATE_GRN'),
  UPDATE_GRN: createRequestTypes('UPDATE_GRN'),
  UPDATE_GRN_STATUS: createRequestTypes('UPDATE_GRN_STATUS'),
  DELETE_GRN: createRequestTypes('DELETE_GRN'),
  GET_DOWNLOAD_GRN_DATA: createRequestTypes('GET_DOWNLOAD_GRN_DATA'),
  UPDATE_GRN_WORKFLOW_STEP: createRequestTypes('UPDATE_GRN_WORKFLOW_STEP'),
  QUICK_UPDATE_GRN: createRequestTypes('QUICK_UPDATE_GRN'),
  SEND_GRN_EMAIL_TO_VENDOR: createRequestTypes('SEND_GRN_EMAIL_TO_VENDOR'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param grnId
 * @param grnEntityId
 * @param grnEntityType
 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class GRNActions {
  /**
 * @param {*} fileType - The type of the file.
 * @param {*} orgId - The ID of the organization.
 * @param {*} tenantId - The ID of the tenant.
 * @param {*} grnId - The ID of the GRN .
 * @param {*} grnEntityId - The ID of the GRN entity.
 * @param {*} grnEntityType - The type of the GRN entity.
 * @param {*} status - The status of the entity.
 * @param {*} limit - The maximum number of results to return per page.
 * @param {*} page - The page number.
 * @param {*} tenantSellerId - The ID of the tenant seller.
 * @param {*} selectedEntityType - The selected entity type.
 * @param {*} searchKeyword - The keyword used for searching.
 * @param {*} columns - An string of columns to include in the result.
 *
 * @returns {file} - The downloaded PDF of GRN Table
 */
  downloadGRNData = (payload, callback) => action(grnActionTypes.GET_DOWNLOAD_GRN_DATA.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} getDownloadGRNLoading
   * @return
   */
  getDownloadGRNDataLoading = (getDownloadGRNLoading) => action(grnActionTypes.GET_DOWNLOAD_GRN_DATA.LOADING, {
    getDownloadGRNLoading,
  })

  /**
   *
   * @param {*} downloadGRNData
   * @return
   */
  getDownloadGRNDataSuccess = (downloadGRNData) => action(grnActionTypes.GET_DOWNLOAD_GRN_DATA.SUCCESS, {
    downloadGRNData,
  })

  /**
   * @return
   * @param page
   * @param poId
   * @param tenantId
   * @param grnEntityId
   * @param grnEntityType
   * @param status
   * @param limit
   * @param tenantSellerId
   * @param selectedEntityType
   * @param grnId
   * @param searchKeyword
   */
  getGRN = (tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn, callback, excludeGRNIds, excludeGRNVendorIds, is_list, billingStatus) => action(grnActionTypes.GET_GRN.REQUEST, {
    tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn, callback, excludeGRNIds, excludeGRNVendorIds, is_list, billingStatus
  })

  /**
   *
   * @param {*} getGRNLoading
   * @return
   */
  getGRNLoading = (getGRNLoading) => action(grnActionTypes.GET_GRN.LOADING, {
    getGRNLoading,
  })

  /**
   * @return
   * @param grnData
   */
  getGRNSuccess = (grnData) => action(grnActionTypes.GET_GRN.SUCCESS, {
    grnData,
  })

  /**
   *
   * @param {*} tenantId
   * @param {*} grnId
   * @return
   */
  getGRNById = (tenantId, grnId, callback) => action(grnActionTypes.GET_GRN_BY_ID.REQUEST, {
    tenantId, grnId, callback,
  })

  /**
   *
   * @param {*} getGRNByIdLoading
   * @return
   */
  getGRNByIdLoading = (getGRNByIdLoading) => action(grnActionTypes.GET_GRN_BY_ID.LOADING, {
    getGRNByIdLoading,
  })

  /**
   * @return
   * @param selectedGRN
   * @param grnData
   */
  getGRNByIdSuccess = (selectedGRN) => action(grnActionTypes.GET_GRN_BY_ID.SUCCESS, {
    selectedGRN,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  createGRN = (payload, callback) => action(grnActionTypes.CREATE_GRN.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param {*} createGRNLoading
   * @return
   */
  createGRNLoading = (createGRNLoading) => action(grnActionTypes.CREATE_GRN.LOADING, {
    createGRNLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateGRN = (payload, callback) => action(grnActionTypes.UPDATE_GRN.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param {*} updateGRNLoading
   * @return
   */
  updateGRNLoading = (updateGRNLoading) => action(grnActionTypes.UPDATE_GRN.LOADING, {
    updateGRNLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateGRNStatus = (payload, callback) => action(grnActionTypes.UPDATE_GRN_STATUS.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param {*} updateGRNStatusLoading
   * @return
   */
  updateGRNStatusLoading = (updateGRNStatusLoading) => action(grnActionTypes.UPDATE_GRN_STATUS.LOADING, {
    updateGRNStatusLoading,
  })

  /**
   * @param tenantId
   * @param grnId
   * @param callback
   * @return {{type: *}}
   */
  deleteGrn = (tenantId, grnId, callback) => action(grnActionTypes.DELETE_GRN.REQUEST, {
    tenantId, grnId, callback,
  })

  /**
   *
   * @param deleteGrnLoading
   * @return {{type: *}}
   */
  deleteGrnLoading = (deleteGrnLoading) => action(grnActionTypes.DELETE_GRN.LOADING, {
    deleteGrnLoading,
  })

  updateGRNWorkflowStep = (payload, callback) => action(grnActionTypes.UPDATE_GRN_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updateGRNWorkflowStepLoading
   * @return {{type: *}}
   */
  updateGRNWorkflowStepLoading = (updateGRNWorkflowStepLoading) => action(grnActionTypes.UPDATE_GRN_WORKFLOW_STEP.LOADING, {
    updateGRNWorkflowStepLoading,
  })

  quickUpdateGRN = (payload, callback, rollback) => action(grnActionTypes.QUICK_UPDATE_GRN.REQUEST, {
    payload, callback, rollback
  })

  /**
   *
   * @param updateGRNWorkflowStepLoading
   * @return {{type: *}}
   */
  quickUpdateGRNLoading = (quickUpdateGRNLoading) => action(grnActionTypes.QUICK_UPDATE_GRN.LOADING, {
    quickUpdateGRNLoading,
  })

  sendGRNMailToVendor = (payload, callback) => {
    return action(grnActionTypes.SEND_GRN_EMAIL_TO_VENDOR.REQUEST, {
      payload,
      callback,
    });
  };

  sendGRNMailToVendorLoading = (sendGRNMailToVendorLoading) => action(grnActionTypes.SEND_GRN_EMAIL_TO_VENDOR.LOADING, {
    sendGRNMailToVendorLoading,
  })
}

export default new GRNActions();
